<div class="sale-template-result">
  <div class="container-fluid">
    <div class="bg-white mt-4">
      <div class="row">
        <div class="col-auto">
          <h5 class="ps-2">
            <span *ngIf="!isSalesCompany"> Viewer Templates </span>
            <span *ngIf="isSalesCompany"> Sale Templates </span>
            <!--<i class="fa fa-spinner fa-spin" *ngIf="isLoader"></i>-->
          </h5>
        </div>
        <div class="col">
          <button type="button"
                  class="btn btn-primary h-btn-search-box btn-sm float-end"
                  (click)="openSaleTemplateCategoriesPopup()">
            <i class="fa fa-plus"></i> Add Template
          </button>
          <app-search-box placeholder="Search..."  class="float-end me-2"
                          (searchChange)="applyFilter($event)">
          </app-search-box>

        </div>
      </div>
      <div class="table table-responsive data-grid mt-1 sticky-header-table ">
        <table mat-table matSort #saleTemplateSort [dataSource]="dataSource" class="table">
          <ng-container matColumnDef="name">
            <th
              mat-header-cell
              class="category-heading w-6-rem ps-0 cursor-pointer"
              *matHeaderCellDef
                (click)="sortTable('name')"
            >
              Template Name <i class="fa fa-sort ms-1"></i>
            </th>
            <td mat-cell *matCellDef="let element" class="ps-0">
              {{ element.name }}
            </td>
          </ng-container>

          <ng-container matColumnDef="description">
            <th
              mat-header-cell
              class="description-heading w-6-rem cursor-pointer"
              *matHeaderCellDef
                (click)="sortTable('description')"
            >
              Description <i class="fa fa-sort ms-1"></i>
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.description }}
            </td>
          </ng-container>

          <ng-container matColumnDef="categoryCount">
            <th
              mat-header-cell
              class="category-count-heading w-6-rem cursor-pointer"
              *matHeaderCellDef
                 (click)="sortTable('categoryCount')"
            >
              Total Catgories <i class="fa fa-sort ms-1"></i>
            </th>
            <td mat-cell *matCellDef="let element" class="ps-4">
              {{ element.categoryCount }}
            </td>
          </ng-container>

          <ng-container matColumnDef="action">
            <th
              mat-header-cell
              class="action-heading w-3-rem"
              *matHeaderCellDef
            >
              Action
            </th>
            <td mat-cell *matCellDef="let element">
              <button
                type="button"
                (click)="openSaleTemplateCategoriesPopup(element)"
                class="btn btn-outline-primary btn-sm"
              >
                <i class="far fa-edit"></i>
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns$.value; sticky: true"></tr>
          <tr
            mat-row
            *matRowDef="
              let row;
              columns: displayedColumns$.value;
              let vetUserIndex = index
            "
            class="border-start-0 border-end-0 pointer pt-2"
          ></tr>
        </table>

        <!--<div class="col-md-12 text-center" *ngIf="isLoader">
          Loading <i class="fa fa-spinner fa-spin"></i>
        </div>-->
      </div>
    </div>
  </div>
</div>
